import { Component, OnInit } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';

declare var particlesJS: any;

export enum BackgroundType {
    NATIVE_PARTICLE = 'nativeParticle',
    FIRE_FLY = 'firefly',
    PARTICLES_JS = 'particlesJs',
}

@Component({
    selector: 'background-control',
    templateUrl: 'background.control.html',
    styleUrl: 'background.control.scss',
    standalone: false,
})
export class BackgroundControl extends ControlBase implements OnInit {
    public actualParticlesParams: object = {};
    public fireFlyCount: number[] = new Array(15);
    public nativeParticleCount: number[] = new Array(100);

    // TODO BackgroundType.PARTICLES_JS
    private bgType: string[] = [BackgroundType.NATIVE_PARTICLE, BackgroundType.FIRE_FLY];
    public currentBGType: BackgroundType;

    //TODO LATER: implement BGType dependent background changes(it should be used where the header control is,
    //and in the afterviewinit we have to set an additional css class: particleJs, nativeParticle, and the current) then override the bg:
    //header.firefly {
    //    background: url("images/dark-forest.jpg") !important;
    //}
    //firefly: dark forest, nativeparticle: night city, particlyJs: currentbackground
    //, we need to add settings to ioc to every module, and we have to add a actual BG property
    //to the settings in this module
    public ngOnInit(): void {
        this.currentBGType = <BackgroundType>this.bgType.getRandomValue();
        this.settings.backGroundType = this.currentBGType;
        switch (this.currentBGType) {
            case BackgroundType.NATIVE_PARTICLE:
            case BackgroundType.FIRE_FLY:
            case BackgroundType.PARTICLES_JS:
                break;
            default:
                throw new Error('Invalid bgType:' + this.currentBGType);
        }

        setTimeout(() => {
            switch (this.currentBGType) {
                case BackgroundType.NATIVE_PARTICLE:
                    $('.circle').fadeOut(20000, () => {
                        $('#native-particle').remove();
                        this.resetScrollBar();
                    });
                    break;
                case BackgroundType.FIRE_FLY:
                    $('.firefly').fadeOut(8000, () => {
                        $('#firefly').remove();
                        this.resetScrollBar();
                    });
                    break;
                case BackgroundType.PARTICLES_JS:
                    $('#particles-js').fadeOut(20000, () => {
                        $('#particles-js').remove();
                        this.resetScrollBar();
                    });
                    break;
            }
        }, 3000);
    }

    public ngAfterViewInit(): void {
        switch (this.currentBGType) {
            case BackgroundType.PARTICLES_JS:
                particlesJS('particles-js', {
                    particles: {
                        number: {
                            value: 80,
                            density: {
                                enable: true,
                                value_area: 800,
                            },
                        },
                        color: {
                            value: '#ffffff',
                        },
                        shape: {
                            type: 'circle',
                            stroke: {
                                width: 0,
                                color: '#000000',
                            },
                            polygon: {
                                nb_sides: 5,
                            },
                            image: {
                                src: 'img/github.svg',
                                width: 100,
                                height: 100,
                            },
                        },
                        size: {
                            value: 3,
                            random: true,
                            anim: {
                                enable: false,
                                speed: 40,
                                size_min: 0.1,
                                sync: false,
                            },
                        },
                        line_linked: {
                            enable: true,
                            distance: 150,
                            color: '#ffffff',
                            opacity: 0.4,
                            width: 1,
                        },
                        move: {
                            enable: true,
                            speed: 4,
                            direction: 'none',
                            random: false,
                            straight: false,
                            out_mode: 'out',
                            bounce: false,
                            attract: {
                                enable: false,
                                rotateX: 600,
                                rotateY: 1200,
                            },
                        },
                    },
                    interactivity: {
                        detect_on: 'canvas',
                        events: {
                            onhover: {
                                enable: true,
                                mode: 'repulse',
                            },
                            onclick: {
                                enable: true,
                                mode: 'push',
                            },
                            resize: true,
                        },
                        modes: {
                            grab: {
                                distance: 400,
                                line_linked: {
                                    opacity: 1,
                                },
                            },
                            bubble: {
                                distance: 400,
                                size: 40,
                                duration: 2,
                                opacity: 8,
                                speed: 3,
                            },
                            repulse: {
                                distance: 200,
                                duration: 0.4,
                            },
                            push: {
                                particles_nb: 4,
                            },
                            remove: {
                                particles_nb: 2,
                            },
                        },
                    },
                    retina_detect: false,
                });
                break;
        }
    }

    private resetScrollBar(): void {
        $('body').css('overflow-x', 'auto');
    }
}
